import type { DialogConfirmProps } from './DialogConfirm.types'
import Dialog from '../Dialog'

const DialogConfirm = ({ fixedWidth = 'sm', ...props }: DialogConfirmProps) => {
  return <Dialog fixedWidth={fixedWidth} {...props} />
}

DialogConfirm.displayName = 'BaseDialogConfirm'

export default DialogConfirm
